import React from 'react'
import { Typography, Box, Link, AppBar,  Stack } from '@mui/material';

import { ReactComponent as FacebookIcon } from "../assets/svg/facebook.svg";
import { ReactComponent as InstagramIcon } from "../assets/svg/instagram.svg";
export default function Footer() {

    const style = {
        body: {
            width: "100%",
        },
        icons: {
            color: theme => theme.palette.text.secondary,
            display: "inline-block",
            height: 30,
            width: 30,
            marginRight: 2,
            marginBottom: 1
        },
        footer: {
            bottom: 0
        },
        iconInherit: {
            height: "inherit",
            width: "inherit",
            color: "inherit"
        }
    }
    const socialAccount = {
        facebook: "https://m.facebook.com/PambayangAklatanNgBaliwag/?tsid=0.6157790752961845&source=result",
        instagram: "https://www.instagram.com/baliwaglibrary/"
    }
    return (
        <Box>
            <AppBar position="sticky" color="default" sx={style.footer} >
                <Stack direction={"column"} alignItems="center" justifyContent="center">
                    <Typography color="default">
                        © {new Date().getFullYear()} Baliwag Municipal Library
                    </Typography>
                    <Stack direction="row">
                        <Link target="_blank" href={socialAccount.facebook} sx={style.icons}>
                            <FacebookIcon sx={style.iconInherit} />
                        </Link>
                        <Link target="_blank" href={socialAccount.instagram} sx={style.icons}>
                            <InstagramIcon sx={style.iconInherit} />
                        </Link>
                    </Stack>
                </Stack>
            </AppBar>
        </Box>
    )
}
